"use strict";

exports.__esModule = true;
exports.isReducedTopSpace = exports.isReducedBottomSpace = void 0;
var TEXT_BLOCK_CHARS = 'TextBlock';
var isReducedTopSpace = function isReducedTopSpace(el, targetId) {
  var _el$parentElement, _el$parentElement$pre;
  if (targetId === void 0) {
    targetId = TEXT_BLOCK_CHARS;
  }
  return el == null ? void 0 : (_el$parentElement = el.parentElement) == null ? void 0 : (_el$parentElement$pre = _el$parentElement.previousSibling) == null ? void 0 : _el$parentElement$pre.id.includes(targetId);
};
exports.isReducedTopSpace = isReducedTopSpace;
var isReducedBottomSpace = function isReducedBottomSpace(el, targetId) {
  var _el$parentElement2, _el$parentElement2$ne;
  if (targetId === void 0) {
    targetId = TEXT_BLOCK_CHARS;
  }
  return el == null ? void 0 : (_el$parentElement2 = el.parentElement) == null ? void 0 : (_el$parentElement2$ne = _el$parentElement2.nextSibling) == null ? void 0 : _el$parentElement2$ne.id.includes(targetId);
};
exports.isReducedBottomSpace = isReducedBottomSpace;